export var version = "3.9.0-alpha.4";
//# sourceMappingURL=version.js.map